import React, { useEffect, useContext, useState } from "react";
import { round } from "../../../utils/helpers";


const optionsUsd = { style: 'currency', currency: 'USD' };
const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);

const buildTarficacionData = (cober, vs) => {
    console.log("🚀 ~ file: help.jsx ~ line 10 ~ buildTarficacionData ~ vs", vs)
    let data = {
        suma: vs.suma,
        catactiv: vs.actividadEconomica,
        inmo: vs.monedaIngreso == 1 ? 'C$' : 'US',
        inme: vs.montoIngreso,
        edad: vs.edad
    };
    let coverageIdsStr = "[";
    cober.forEach((item) => {
        data[`Cob${item.idCob}`] = 1;
        coverageIdsStr = coverageIdsStr + `${item.idCob},`;
    });
    coverageIdsStr = coverageIdsStr.substring(0, coverageIdsStr.length - 1) + "]";
    data["coverageIds"] = coverageIdsStr;
    return data;
}



const calculateAgeAct = (birdhtday) => {
    var today = new Date();
    var age = today.getFullYear() - birdhtday.getFullYear();
    var m = today.getMonth() - birdhtday.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birdhtday.getDate())) {
        age--;
    }

    var diff = today - birdhtday;

    var dias = Math.floor(diff / 86400000);
    var edadDec = dias / 365.25;
    edadDec = edadDec - age;

    if (edadDec >= 0.5) age++;

    return age;
}

const buildDetTable = (coverages, rates) => {
    let cob = [];
    coverages.map(item => {
        if (item.obligatoria) {
            let cobertura = rates.find(x => x.idCob == item.idCob && x.bIncluirCob == false);
            if (cobertura != undefined)
                cob.push({ "nombre": item.nombre, "valor": numberFormatUsd.format(Number.parseFloat(cobertura.sa).toFixed(2)) });
        }

    })
    return cob;
};

const getAgeActuarial = date => {

    const today = new Date();

    let { age, birthDate } = calculateAge(date);

    const diff = today - birthDate;

    const dias = Math.floor(diff / 86400000);
    let edadDec = dias / 365.25;
    edadDec = edadDec - age;

    if (edadDec >= 0.5) age++;

    return age;

}



const calculateAge = date => {

    const today = new Date();
    const birthDate = new Date(date);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return {
        age,
        birthDate
    };

}


const getDateFronIdentity = identity => {

    if (String(identity).length != 16) return null;

    const fecNac = identity.split("-")[1];

    let dia = fecNac.substr(0, 2);
    let mes = fecNac.substr(2, 2);
    let año = fecNac.substr(4, 2);

    let añoActualFecha = new Date().getFullYear().toString();

    let añoActualPrimerosDos = añoActualFecha.substr(0, 2);
    let añoAnteriorPrimerosDos = añoActualPrimerosDos - 1;

    let añoAnterior = añoAnteriorPrimerosDos + año;
    let añoActual = añoActualPrimerosDos + año;

    let añoAplicar = "";
    if (añoActualFecha < añoActual) {
        añoAplicar = añoAnterior;
    } else {
        añoAplicar = añoActual;
    }

    return new Date(añoAplicar, mes - 1, dia);

}

const getResumen = (tarifas = []) => {

    if (tarifas.length === 0) return 0;

    return tarifas.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');

}

const buildPoliza = (data, src) => {
    console.log("🚀 ~ file: help.jsx ~ line 138 ~ buildPoliza ~ data", data)
    let PolCobs = [];
    let policy = {
        "Plan": data.idPlan,
        "SA": data.suma,
        "Prima": data.montoPagar,
        "Descuento": 0,
        "PrimaDE": 0,
        "PrimaNeta": data.montoPagar,
        "PrimaDE": 0,
        "PrimaExonerada": 0,
        "Impuesto": 0,
        "Total": data.montoPagar,
        "Estado": 0,
        "OpcionEntrega": data.esDelivery ? "Delivery" : "En sucursal",
        "Source": src,
        "clausulaArbitraje": data.aceptaPocesoArbitraje
    };

    let Oa = {
        "SA": data.suma,
        "peActividad": data.actividadEconomica,
        "peEdadAct": data.edad,
        "peIngreso": data.montoIngreso,
        "peIngresoMoneda": data.monedaIngreso == '1' ? 'C$' : 'U$',
        "peFNacimiento": data.fechaNacimiento,
    };
    console.log("🚀 ~ file: help.jsx ~ line 165 ~ buildPoliza ~ Oa", Oa)

    let Asegurado =
    {
        "TipoId": data.tipoIdentidad,
        "NumId": data.numeroIdentificacion,
        "Nombre": data.nombres,
        "Apellido": data.apellidos,
        "TelefonoCasa": data.telefonoCasa,
        "TelefonoCelular": data.telefonoPersonal,
        "Email": data.correoElectronico,
        "EstadoCivil": data.estadoCivil
    };
    data.catalogos.rates.forEach(element => {
        let titleRate = data.catalogos.coberturas.find(x => x.idCob == element.idCob);
        if (titleRate !== null) {
            element["Nombre"] = titleRate.nombre;
            element["orden"] = titleRate.orden;
        }
        element["mprimabruta"] = element.prima;
        element["PrimaGravada"] = 0;
        element["pdescuento"] = 0;
        element["mdescuento"] = 0;
        PolCobs.push(element);
    });
    policy["FormaPagos"] = "";

    if (!data.esTelepago) {
        if (data.nombreTarjeta !== null || data.nombreTarjeta !== '') {
            const date = data.expiracionTarjeta.split('/');
            let FormaPagos = {
                "Forma": "TARJ",
                "Nombre": data.nombreTarjeta,
                "Numero": data.numeroTarjeta,
                "VtoMes": date[0],
                "VtoAnio": date[1],
                "Cvv": data.cvvTarjeta,
                "Monto": data.montoPagar,
                "MonedaPago": "U$"
            }
            policy["CVV"] = data.cvvTarjeta;
            policy["FormaPagos"] = FormaPagos;
        }
    }

    let lstBeneficiario = [];

    //BENEFICIARIO
    let Beneficiario1 = {
        nombre: data.nombresApellidos1,
        parentesco: data.parentesco1,
        xparentesco: '',
        menor: data.edad1 < 18 ? true : false,
        participacion: data.porcentajeBeneficio1,
        repLegal: `${data.nombreRepresentante1} ${data.apellidoRepresentante1}`,
        xcedulaRepresentante: data.numeroIdentificacionRepresentante1,
        bprincipal:true
    }
    lstBeneficiario.push(Beneficiario1);

    if (data.esBeneficiario2) {
        let Beneficiario2 = {
            nombre: data.nombresApellidos2,
            parentesco: data.parentesco2,
            xparentesco: '',
            menor: data.edad2 < 18 ? true : false,
            participacion: data.porcentajeBeneficio2,
            repLegal: `${data.nombreRepresentante2} ${data.apellidoRepresentante2}`,
            xcedulaRepresentante: data.numeroIdentificacionRepresentante2,
            bprincipal:false
        }
        lstBeneficiario.push(Beneficiario2);
    }

    policy["Beneficiarios"] = lstBeneficiario;
    policy["PolCobs"] = PolCobs;
    policy["Oa"] = Oa;
    policy["Asegurado"] = Asegurado;

    return policy;

}

export { buildTarficacionData, calculateAgeAct, buildDetTable, getResumen, getDateFronIdentity, getAgeActuarial, buildPoliza }